import { AxiosResponse } from 'axios';
import { bookBalance, bookBalanceExport } from '@/api/bookBalance';
import { AppError } from '@/errors/appError';
import { baseListExportService, baseListService, isRequestCanceled } from '@/services/baseService';
import { IBookBalanceApiListResponse, IBookBalanceFilters } from '@/types/bookBalance';
import { IListParams } from '@/types/service';

export const bookBalanceService = {
    async list(
        params: IListParams<IBookBalanceFilters> & { extraParams?: { currencyId?: number | null } }
    ): Promise<AxiosResponse<IBookBalanceApiListResponse>> {
        try {
            // Extract currencyId from extraParams and pass it directly to API
            const currencyId = params.extraParams?.currencyId;
            // Create a custom API call wrapper that includes currencyId
            const apiCallWrapper = (apiParams: any, config?: any) => {
                return bookBalance(
                    {
                        ...apiParams,
                        currencyId: currencyId,
                    },
                    config
                );
            };
            const response = await baseListService<IBookBalanceApiListResponse>(apiCallWrapper, params);
            return response;
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('Book Balance API Error:', e);
            throw new AppError(`Unable to load book balance list, request error`, { cause: e });
        }
    },

    async export(params: IListParams<IBookBalanceFilters> & { extraParams?: { currencyId?: number | null } }): Promise<AxiosResponse<Blob>> {
        try {
            const apiCallWrapper = (apiParams: any) => {
                return bookBalanceExport({
                    ...apiParams,
                });
            };
            const response = await baseListExportService(apiCallWrapper, params);
            return response;
        } catch (e) {
            console.error('Book Balance Export API Error:', e);
            throw new AppError(`Unable to export book balance, request error`, { cause: e });
        }
    },
};
